__turbopack_context__.v({
  "description": "field-module-scss-module__hy3pua__description",
  "error": "field-module-scss-module__hy3pua__error",
  "label": "field-module-scss-module__hy3pua__label",
  "required_mark": "field-module-scss-module__hy3pua__required_mark",
  "root": "field-module-scss-module__hy3pua__root",
});
